'use strict';
/**
 * Create a new LineComment.
 *
 * @param {String} `str` string of JavaScript
 * @param {Object} `token` Parsed AST token
 */

var _classCallCheck = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var LineComment = function LineComment(str, token) {
  _classCallCheck(this, LineComment);

  Object.assign(this, token);
  this.range = token.range || [token.start, token.end];
  this.raw = token.value;
  this.value = this.raw.trim();
};
/**
 * expose `LineComment`
 */


module.exports = LineComment;